/**
 * Feature toggles for client UI. Backend routes stay enabled; hide surfaces until launch.
 */
export const FEATURE_INTERVIEW_UI = true;
export const FEATURE_CURA_UI = true;
